import React from "react";
import { RobotIcon, SmileyIcon, SparkleIcon } from "../Pages/Auth/onboarding/icons";
import { ChatBubbleIcon } from "../Pages/Dashboard/icons";
import LauncherGlyph from "../Pages/Customization/LauncherGlyph";
import { isLucideIcon } from "../Pages/Customization/launcherIcons";

// Keyed on what the API stores. Customization works in its own short ids and
// translates on the way in and out (bubble <-> chat-bubble), so both spellings
// are accepted here and every screen can pass a theme straight through.
const GLYPHS = {
  "chat-bubble": <ChatBubbleIcon />,
  bubble: <ChatBubbleIcon />,
  smile: <SmileyIcon />,
  spark: <SparkleIcon />,
  logo: <RobotIcon />,
};

/**
 * The assistant's face: its uploaded avatar, else its chosen launcher icon,
 * else the robot placeholder.
 *
 * @param {object} theme flat widget theme, from readWidgetTheme
 * @param {number} size  px, for library icons (the built-ins are fixed)
 */
export default function WidgetGlyph({ theme, size = 22 }) {
  if (theme?.avatarUrl) return <img src={theme.avatarUrl} alt="" />;

  // Icons picked from the library are stored as "lucide:Name".
  if (isLucideIcon(theme?.launcherStyle)) {
    return (
      <LauncherGlyph
        value={theme.launcherStyle}
        size={size}
        fallback={<RobotIcon />}
      />
    );
  }

  return GLYPHS[theme?.launcherStyle] || <RobotIcon />;
}
